import type { IconGlyph } from '../icon';

import { iconHomeThick } from './home-thick';

/**
 * Tractie `home` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/home.jsx`.
 * Verbatim copy of the SVG `d` attribute.
 */
export const iconHome: IconGlyph = {
  name: 'home',
  path: 'M20.32 10.62 12 3.68l-8.32 6.94c-.21.18-.24.49-.06.7s.49.24.7.06l.68-.57v7.68c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7.68l.68.57c.21.18.53.15.7-.06.18-.21.15-.53-.06-.7M13 19h-2v-4.5c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5zm5-.5c0 .28-.22.5-.5.5H14v-4.5c0-.83-.67-1.5-1.5-1.5h-1c-.83 0-1.5.67-1.5 1.5V19H6.5c-.28 0-.5-.22-.5-.5V9.98l6-5 6 5z',
  selected: iconHomeThick,
};
